export default __webpack_public_path__ + "static/media/icon-menu-visits.b2b2a0d2.svg";